import api from "../../../shared/api/client";

export async function getMe() {
  const { data } = await api.get("/auth/me");
  return data;
}

export async function login(body) {
  const { data } = await api.post("/auth/login", body);
  return data;
}

export async function logout() {
  const { data } = await api.post("/auth/logout");
  return data;
}

export async function patchMe(body) {
  const { data } = await api.patch("/auth/me", body);
  return data;
}
